@if (anchor) {
  <a [id]="anchor"></a>
}
<kb-html [appEditorId]="editorIds?.content" [html]="attributes.content" [attributeAllowlist]="attributeAllowlist"></kb-html>
@if (createSectionButton) {
  <app-fs-button [value]="createSectionButton"></app-fs-button>
}
